<template>
  <page>
    <template slot="title">Системы учёта</template>
    <template slot="section">
      <columns valign="center">
        <column size="10">
          <p>Стоимость энергоресурсов обуславливает кардинальное изменение отношения собственников компаний к организации энергоучета. Необходимо внедрение эффективных средств учета, способствующих снижению затрат на энергоресурсы.<br/>Использование автоматизированной информационно-измерительной системы коммерческого учета энергоресурсов (АИИС КУЭ) позволяет:</p>
          <ul>
            <li>осуществлять точный и быстрый контроль над потреблением электроэнергии;</li>
            <li>повысить достоверность учета;</li>
            <li>оперативно получать все виды данных;</li>
            <li>контролировать параметры всех энергоносителей;</li>
            <li>выявлять возможные пути экономии.</li>
          </ul>
          <p>ООО «АРК-ЭнергоСбыт» предлагает комплексную услугу по организации и внедрению автоматизированных систем коммерческого учета, соответствующих требованиям оптового рынка электроэнергии и мощности (ОРЭМ). Создание АИИС КУЭ включает:</p>
          <ul>
            <li>предпроектное обследование;</li>
            <li>­проектирование (проектные работы, разработку технического задания, разработку и согласование техно-рабочего проекта, создание эксплуатационной документации);</li>
            <li>­поставку необходимого оборудования и материалов;</li>
            <li>­строительно-монтажные и пуско-наладочные работы;</li>
            <li>­метрологическое обеспечение (сертификацию системы путем внесения в Госреестр средств измерений, поверку системы, разработку методики измерений, проведение экспертизы методики с ОАО «АТС» и внесение МИ в Федеральный реестр СИ);</li>
            <li>­опытную эксплуатацию и сдачу системы в постоянную эксплуатацию.</li>
          </ul>
          <p>После внедрения АИИС КУЭ на объекте Клиент имеет возможность:</p>
          <ul>
            <li>покупать электроэнергию и мощность по оптовым ценам;</li>
            <li>­получать достоверные данные коммерческого учета электроэнергии для организации расчетов;</li>
            <li>­управлять потреблением за счет оперативного контроля расхода электроэнергии и своевременного принятия организационно-технических решений, обеспечивающих более рациональное использование энергоресурсов;</li>
            <li>­исключить хищения и снизить потери электроэнергии.</li>
            <li>Результат – снижение объема потребляемых энергоресурсов без ущерба для Вашей основной деятельности, в том числе, уменьшение размера ежемесячного платежа.</li>
          </ul>
        </column>
        <!--<column size="4" align="right">
          <line-break/>
          <quote>
            <heading rl>«Этим ребятам я бы доверял!»</heading>
            <p rl>Владимир Путин</p>
          </quote>
        </column>-->
      </columns>
    </template>
    <template slot="aside">
      <aside-image :image="imageBg"/>
    </template>
  </page>
</template>

<script>
import imageBg from '../../static/i/img-11.jpg';

import Columns from '@/components/columns/Columns';
import Column from '@/components/columns/Column';
import Page from '@/components/Page';
import AsideImage from '@/components/AsideImage';

export default {
  components: {
    Columns,
    Column,
    Page,
    AsideImage,
  },
  data: () => {
    return {
      imageBg: imageBg,
    }
  }
}
</script>



// WEBPACK FOOTER //
// Accounting.vue?0fd78b7a